'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$2() {
  this.bfz = null;
  this.bfx = null;
  this.bfy = false;
  this.bfv = null;
  this.bfw = false;
  this.bfA = false;
  this.bfB = false;
  this.bfz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$2 as $c_Lpresto_PrestoRouter$$anon$2 };
$p = $c_Lpresto_PrestoRouter$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$2;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$2() {
}
export { $h_Lpresto_PrestoRouter$$anon$2 as $h_Lpresto_PrestoRouter$$anon$2 };
$h_Lpresto_PrestoRouter$$anon$2.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bfz;
});
$p.t = (function() {
  if ((!this.bfy)) {
    this.bfx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfy = true;
  }
  return this.bfx;
});
$p.ae = (function() {
  if ((!this.bfw)) {
    this.bfv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfw = true;
  }
  return this.bfv;
});
$p.w = (function() {
  if ((!this.bfB)) {
    this.bfA = false;
    this.bfB = true;
  }
  return this.bfA;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$2, "presto.PrestoRouter$$anon$2", ({
  NK: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$2 as $d_Lpresto_PrestoRouter$$anon$2 };
//# sourceMappingURL=presto.-Presto-Router$$anon$2.js.map
